import { BaseApi } from '../apiBase';
import type { Form, FormListItem } from '../types/form';

const EVENT_FORMS_API_PATH = '/events/:event_slug/forms';
const EVENT_FORM_API_PATH = '/events/:event_slug/forms/:form_slug';

class EventFormsApi extends BaseApi {
  async getEventForms(eventSlug: string): Promise<FormListItem[]> {
    const path = EVENT_FORMS_API_PATH.replace(':event_slug', eventSlug);
    return this.get<FormListItem[]>(path);
  }

  async getEventForm(eventSlug: string, formSlug: string): Promise<Form> {
    const path = EVENT_FORM_API_PATH
      .replace(':event_slug', eventSlug)
      .replace(':form_slug', formSlug);
    return this.get<Form>(path);
  }
}

export const eventFormsApi = new EventFormsApi();